import ConfirmPhoneForm from "../ConfirmPhoneFromsClass";

export default class ChangePhone extends ConfirmPhoneForm {
    constructor() {
        super('.forms_group_change_phone');
    }

    /**
     * Change phone
     */
    formValidator($form) {
        let $this = this,
            $inF = $form.validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {

                    //Check actions
                    let action = $(form).attr('action'),
                        dataTo = $(form).attr('data-to'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $($this.formsGroup).find(' > form .btn-area a.to_form').addClass('disabled');

                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData,
                        dataType: "json"
                    })
                    .then(function (resp) {
                        if (!resp.success) {
                            $this.showFormError($form, resp.message);
                            return;
                        }

                        $this.hideFormError($form);

                        //Send sms and show code form
                        if(resp.data['change_phone_1']) {
                            $(form).animate({opacity: 0}, 200, function() {
                                //Hide from
                                $(form).hide();

                                //Initial sms timer
                                if($(dataTo).attr('data-timer')) {
                                    $this.timerSendSms($(dataTo));

                                    $(dataTo).on('click', '.send_sms_again a', function (e) {
                                        e.preventDefault();
                                        if($(this).hasClass('active')) {
                                            $this.timerSendSms($(dataTo));
                                            if($(dataTo).attr('data-parent')) {
                                                //TODO: need reset form?
                                                $($(dataTo).attr('data-parent')).trigger('submit');
                                            }
                                        }
                                    });

                                    //Set phone number
                                    let phone = $(form).find('input[type="tel"]').val();
                                    $(dataTo).find('.header_info .number').html(phone);
                                    $(dataTo).find('input[name="phone_number"]').val(phone);
                                }

                                //Show next block
                                $(dataTo).show();
                                $(dataTo).animate({opacity: 1}, 200);
                            });
                        }

                        //Success change phone
                        if(resp.data['change_phone_2']) {
                            if(resp.data['phone']) {
                                $('#profile_user_info').find('input[name=phone]').val(resp.data['phone'].slice(2, 12));
                                $form.closest('.wrap_fade_popup').find('.header .icon-clear').trigger('click');
                            }
                        }
                    })
                    .fail(function (xhr) {
                        $this.ajaxErrorForm($inF, xhr);
                    })
                    .always(function () {
                        $(form).find('button[type="submit"]').prop('disabled', false);
                        $($this.formsGroup).find('> form .btn-area a.to_form').removeClass('disabled');
                    });
                }
            });

        this.initForms.push($inF);

        //Close form
        let $wrapF = $form.closest('.wrap_fade_popup');
        $wrapF.find('.header .icon-clear, .close-popup').on('click', function (e) {
            close();
        });

        function close() {
            //Clear
            $wrapF.find('form')[0].reset();
            $inF.resetForm();
            $wrapF.find('form .full:not([name="date_from"]):not([name="date_to"])').removeClass('full');

            $wrapF.find('form').fadeOut(function () {
                $wrapF.find('#prof-change-phone').fadeIn(200);
                $wrapF.find('#prof-change-phone').css('opacity', 1);
            });
        }
    }
}
